import Vue from 'vue'
import Lingallery from 'lingallery'
Vue.use(Lingallery)